import { jsxs, jsx } from 'react/jsx-runtime';
import { LegacyIconButton } from '../../navigation/LegacyIconButton/IconButton.es.js';

const root = "_root_1lhvm_1";
const styles = {
	root: root
};

const DateRangePickerNavbar = ({ onNextClick, onPreviousClick }) => {
  return jsxs("div", { className: styles.root, "data-zds": true, children: [jsx(LegacyIconButton, { icon: "arrowSmallLeft", label: "Previous Month", onClick: () => onPreviousClick(), shouldCorrectTooltipPosition: false, tooltipPosition: "southwest", color: "icon-tertiary" }), jsx(LegacyIconButton, { icon: "arrowSmallRight", label: "Next Month", onClick: () => onNextClick(), shouldCorrectTooltipPosition: false, tooltipPosition: "southeast", color: "icon-tertiary" })] });
};

export { DateRangePickerNavbar };
//# sourceMappingURL=DateRangePickerNavbar.es.js.map
